import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  hasEnvCredentials,
  getEnvCredentials,
} from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [apiTokenId, setApiTokenId] = useState("");
  const [apiClientSecret, setApiClientSecret] = useState("");
  const [error, setError] = useState("");

  const envConfigured = hasEnvCredentials();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    const ok = login(apiTokenId.trim(), apiClientSecret.trim());
    if (ok) {
      navigate("/");
    } else {
      setError("Please enter both API Token ID and Client Secret.");
    }
  };

  const handleQuickConnect = () => {
    const creds = getEnvCredentials();
    login(creds.apiTokenId, creds.apiClientSecret);
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-[#00B3E0] flex items-center justify-center font-bold text-black text-xl">
              G
            </div>
            <h1 className="text-2xl font-bold text-[#F8F8F7]">
              Grid Backoffice
            </h1>
          </div>
          <p className="text-[#8A8A8A] text-sm">
            Connect with your Grid API sandbox credentials
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-[#111111] border border-[#222222] rounded-xl p-6 space-y-4"
        >
          {error && (
            <div className="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-2 rounded-lg text-sm">
              {error}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-[#8A8A8A] mb-1">
              API Token ID
            </label>
            <input
              type="text"
              value={apiTokenId}
              onChange={(e) => setApiTokenId(e.target.value)}
              className="w-full bg-[#0A0A0A] border border-[#333333] rounded-lg px-4 py-2.5 text-[#F8F8F7] text-sm font-mono focus:border-[#00B3E0] focus:outline-none"
              placeholder="Enter your API Token ID"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[#8A8A8A] mb-1">
              API Client Secret
            </label>
            <input
              type="password"
              value={apiClientSecret}
              onChange={(e) => setApiClientSecret(e.target.value)}
              className="w-full bg-[#0A0A0A] border border-[#333333] rounded-lg px-4 py-2.5 text-[#F8F8F7] text-sm font-mono focus:border-[#00B3E0] focus:outline-none"
              placeholder="Enter your API Client Secret"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-[#00B3E0] text-black font-semibold py-2.5 rounded-lg hover:bg-[#00C4F5] transition-colors"
          >
            Connect to Grid API
          </button>

          {envConfigured && (
            <>
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-[#222222]" />
                </div>
                <div className="relative flex justify-center text-xs">
                  <span className="px-2 bg-[#111111] text-[#666666]">or</span>
                </div>
              </div>

              <button
                type="button"
                onClick={handleQuickConnect}
                className="w-full bg-[#1A1A1A] border border-[#333333] text-[#F8F8F7] font-medium py-2.5 rounded-lg hover:bg-[#222222] transition-colors text-sm"
              >
                Quick Connect (Pre-configured)
              </button>
            </>
          )}
        </form>

        <div className="mt-4 bg-[#0A1628] border border-[#1A3A5C] rounded-xl p-4">
          <p className="text-[#00B3E0] text-xs font-medium mb-1">
            Grid API Sandbox
          </p>
          <p className="text-[#8A8A8A] text-xs">
            Enter your Grid API credentials to connect.{" "}
            {envConfigured
              ? 'Or use "Quick Connect" with pre-configured credentials.'
              : "Contact your admin for API keys."}
          </p>
        </div>
      </div>
    </div>
  );
}
